import { render } from "./betDetail.vue?vue&type=template&id=eac0c456&scoped=true"
import script from "./betDetail.vue?vue&type=script&lang=js"
export * from "./betDetail.vue?vue&type=script&lang=js"

import "./betDetail.vue?vue&type=style&index=0&id=eac0c456&scoped=true&lang=css"
import "./betDetail.vue?vue&type=style&index=1&id=eac0c456&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eac0c456"]])

export default __exports__